import { render, staticRenderFns } from "./MobilePreventionHealthRequestUpdate.vue?vue&type=template&id=e1edff0a&scoped=true&"
import script from "./MobilePreventionHealthRequestUpdate.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionHealthRequestUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreventionHealthRequestUpdate.vue?vue&type=style&index=0&id=e1edff0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1edff0a",
  null
  
)

export default component.exports